import React from "react";
import { Row, Col } from "antd";
import { getCalculatedPercentage } from "utils/adminUsageDetail/dashboardUtils";
import AnalyticsCard from "../AnalyticsCard/AnalyticsCard";

const AnalyticsSection = ({ smsStatusData, oldSmsStatusData, mmsStatusData, oldMmsStatusData, loading }) => {
  // Helper function to calculate sent messages (total - received - blocked)
  const calculateSentMessages = data => {
    if (!data) return 0;
    return Number(data.totalSMS) - Number(data.totalSMSReceived) - Number(data.totalSMSBlocked);
  };

  // Generate analytics data
  const analyticsData = [
    {
      id: "1",
      type: "sent",
      label: "Total SMS Sent",
      value: calculateSentMessages(smsStatusData),
      icon: <i className="fas fa-paper-plane"></i>,
      cost: false,
      percentage: smsStatusData ? getCalculatedPercentage(calculateSentMessages(smsStatusData), calculateSentMessages(oldSmsStatusData)) : 0
    },
    {
      id: "2",
      type: "coin",
      label: "Total Spent on SMS",
      value: smsStatusData ? ((smsStatusData?.totalSpent || 0) / 100).toFixed(2) : 0,
      icon: <i className="fas fa-coins"></i>,
      cost: true,
      percentage: smsStatusData ? getCalculatedPercentage((smsStatusData?.totalSpent || 0) / 100, (oldSmsStatusData?.totalSpent || 0) / 100) : 0
    },
    {
      id: "3",
      type: "sent",
      label: "Total MMS Sent",
      value: calculateSentMessages(mmsStatusData),
      icon: <i className="fas fa-paper-plane"></i>,
      cost: false,
      percentage: mmsStatusData ? getCalculatedPercentage(calculateSentMessages(mmsStatusData), calculateSentMessages(oldMmsStatusData)) : 0
    },
    {
      id: "4",
      type: "coin",
      label: "Total Spent on MMS",
      value: mmsStatusData ? ((mmsStatusData?.totalSpent || 0) / 100).toFixed(2) : 0,
      icon: <i className="fas fa-coins"></i>,
      cost: true,
      percentage: mmsStatusData ? getCalculatedPercentage((mmsStatusData?.totalSpent || 0) / 100, (oldMmsStatusData?.totalSpent || 0) / 100) : 0
    }
  ];

  return (
    <Row gutter={[16, 16]} className="mt-4">
      {analyticsData?.map(analytics => (
        <Col xs={24} sm={12} md={12} lg={12} xl={12} key={analytics.id}>
          <AnalyticsCard
            id={analytics.id}
            type={analytics.type}
            label={analytics.label}
            value={analytics.value}
            icon={analytics.icon}
            cost={analytics.cost}
            percentage={analytics.percentage}
            loading={loading}
          />
        </Col>
      ))}
    </Row>
  );
};

export default AnalyticsSection;
